import * as React from 'react';
import classNames from 'classnames';
import styles from '../Pages/pageStyles.scss';

const PageFooter: React.FunctionComponent = (): React.ReactElement => (
  <div className={classNames(styles.grecaptchaDisclaimer, styles.footerText)}>
    This site is protected by reCAPTCHA and the Google{' '}
    <a href="https://policies.google.com/privacy">Privacy Policy</a> and{' '}
    <a href="https://policies.google.com/terms">Terms of Service</a> apply.
  </div>
);

export default PageFooter;
